import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78170b51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mask" }

import { watchEffect, ref, getCurrentInstance } from 'vue';

  export interface IProps {
    value: number,
    max: number,
    visible?: boolean,
    showMask?: boolean,
    delayed?: number,
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    value: { default: 1 },
    max: { default: 1 },
    visible: { type: Boolean, default: false },
    showMask: { type: Boolean, default: true },
    delayed: { default: 0 }
  },
  setup(__props: any, { expose }) {

const props = __props as { value: number, max: number, visible: boolean, showMask: boolean, delayed: number }

  

  const visible = ref(false);

  let timer: number;

  watchEffect(() => {
    const value = props.visible;
    clearTimeout(timer);
    if (props.delayed && !value) {
      timer = setTimeout(() => {
        visible.value = value;
      }, props.delayed);
    } else {
      visible.value = value;
    }
  });

  expose({
    instance: getCurrentInstance(),
  });

return (_ctx: any,_cache: any) => {
  const _component_b_progress = _resolveComponent("b-progress")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_b_progress, {
      class: "progress",
      value: props.value,
      max: props.max,
      striped: false,
      height: "0.25rem"
    }, null, 8, ["value", "max"]),
    _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [
      [_vShow, props.showMask]
    ])
  ], 512)), [
    [_vShow, visible.value]
  ])
}
}

})